import { render } from "./UserProfilePage.vue?vue&type=template&id=43b4bac2&ts=true"
import script from "./UserProfilePage.vue?vue&type=script&lang=ts"
export * from "./UserProfilePage.vue?vue&type=script&lang=ts"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__